module.exports = __webpack_public_path__ + "img/thumbnail_SomaliWildAss_m_normal.26e5fd32.png";